import { RouteObject } from "react-router";

const ChildEventRoutes: RouteObject[] = [
  {
    path: ":eventId/edit",
    async lazy() {
      const { EventEditModal } = await import("src/jobs/Job/AppointmentsTab/EventEditModal");
      return { element: <EventEditModal /> };
    },
    async loader(args) {
      const { eventLoader } = await import("src/router/loaders/jobs/Event");
      return eventLoader(args);
    },
  },
  {
    path: ":eventId/invite",
    async lazy() {
      const { SendInviteModal } = await import("src/jobs/Job/AppointmentsTab/SendInviteModal");
      return { element: <SendInviteModal /> };
    },
  },
  {
    path: ":eventId/result",
    async lazy() {
      const { ResultAppointmentModal } = await import("src/jobs/Job/AppointmentsTab/ResultAppointmentModal");
      return { element: <ResultAppointmentModal /> };
    },
  },
  {
    path: ":eventId/result/i360",
    async lazy() {
      const { I360ResultAppointmentModal } = await import("src/jobs/Job/AppointmentsTab/I360ResultAppointmentModal");
      return { element: <I360ResultAppointmentModal /> };
    },
  },
];

export const EventRoutes: RouteObject[] = [
  {
    path: "calendar",
    shouldRevalidate: ({ currentUrl, nextUrl }) => {
      const currentSearchParams = currentUrl.searchParams;
      const nextSearchParams = nextUrl.searchParams;

      return (
        currentSearchParams.get("start_time") !== nextSearchParams.get("start_time") ||
        currentSearchParams.get("end_time") !== nextSearchParams.get("end_time")
      );
    },
    async loader(args) {
      const { calendarEventsLoader } = await import("src/router/loaders/jobs/Event");
      return calendarEventsLoader(args);
    },
    async lazy() {
      const { AppointmentsCalendar } = await import("jobs/Job/AppointmentsTab/AppointmentsCalendar");
      return { element: <AppointmentsCalendar /> };
    },
    children: ChildEventRoutes,
  },
  {
    path: "",
    async loader(args) {
      const { eventsLoader } = await import("src/router/loaders/jobs/Event");
      return eventsLoader(args);
    },
    async lazy() {
      const { AppointmentsList } = await import("jobs/Job/AppointmentsTab/AppointmentsList");
      return { element: <AppointmentsList /> };
    },
    children: ChildEventRoutes,
  },
];
